module.exports = __webpack_public_path__ + "static/media/student-score-top.56070b6e.png";